import { ITranslate } from "@/interfaces/ITranslate";

export const stockRecordTranslate: ITranslate = {
  quantity: "la cantidad",
};
